// The hero's bottom edge, drawn as a voice: silence, two "words", a short tail, silence. The notebook above
// (grid paper) gives way to the clean off-white page below, the way meeting audio turns into knowledge.
export const WAVE = {
  width: 1440,
  height: 110,
  baseline: 70,
  step: 4,
  wavelength: 84,
};

// Each burst is one "word": where it sits (0-1 across), how wide it is, how loud.
const BURSTS = [
  { at: 0.34, spread: 0.075, amp: 30 },
  { at: 0.6, spread: 0.06, amp: 20 },
  { at: 0.78, spread: 0.035, amp: 9 },
];

export function wavePoints(): Array<[number, number]> {
  const { width, baseline, step, wavelength } = WAVE;
  const points: Array<[number, number]> = [];
  for (let x = 0; x <= width; x += step) {
    const t = x / width;
    const loudness = BURSTS.reduce(
      (sum, b) =>
        sum + b.amp * Math.exp(-((t - b.at) ** 2) / (2 * b.spread ** 2)),
      0,
    );
    // A second, slower sine roughens the rhythm so it reads as speech, not a test tone.
    const signal =
      Math.sin((2 * Math.PI * x) / wavelength) *
      (0.75 + 0.25 * Math.sin((2 * Math.PI * x) / (wavelength * 2.7)));
    points.push([x, baseline - loudness * signal]);
  }
  return points;
}

// The voice line on its own, also used as the signature on blog covers.
export const line = wavePoints()
  .map(([x, y], i) => `${i === 0 ? "M" : "L"}${x} ${y.toFixed(1)}`)
  .join("");
const fill = `${line}L${WAVE.width} ${WAVE.height}L0 ${WAVE.height}Z`;

export function SoundWaveEdge() {
  return (
    <svg
      data-testid="sound-wave-edge"
      aria-hidden="true"
      viewBox={`0 0 ${WAVE.width} ${WAVE.height}`}
      preserveAspectRatio="none"
      className="block h-16 w-full sm:h-24 lg:h-28"
    >
      <path d={fill} className="fill-paper-white" />
      <path
        d={line}
        fill="none"
        className="stroke-brand-500/70"
        strokeWidth="1.5"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
    </svg>
  );
}
